import HeaderLogo from "./HeaderLogo";
import NavDropDownMenu from "./NavDropDownMenu";
import NotificationBadge from "./NotificationBadge";

const HeaderNavBar = ({
  isOpen,
  appLogo,
  className,
  onOverlayClick,
  ...rest
}) => (
  <>
    <div
      className={`${
        isOpen ? "fixed top-0 left-0 " : "hidden"
      } lg:hidden  h-screen w-screen bg-black opacity-20 transition-opacity ease-in-out duration-1000`}
      
      onClick={onOverlayClick}
    >
      &nbsp;
    </div>
    <div
      className={`${
        isOpen ? "" : "transform -translate-x-64 lg:transform-none"
      } transition-all duration-700 ease-in-out fixed  lg:relative top-0 lg:top-auto left-0 lg:left-auto  bg-gray-100 lg:bg-white flex-col lg:flex-row flex w-64 lg:w-full overflow-y-auto lg:overflow-auto h-screen  lg:h-full lg:justify-end`}
    >
      <nav>
        <ul {...rest} className={`main-nav ${className ? className : ""}`}>
          <li>
            <div className="bg-white lg:hidden">
              <HeaderLogo imgSrc={appLogo} />
            </div>
          </li>
          <li>
            <button className="nav-btn">
              <span>Dugout</span>
            </button>
          </li>

          <NavDropDownMenu
            menuTitle="Price Change Stats"
            items={[
              { title: "Assistant Manager", link: "/#" },
              { title: "Player Performance Report", link: "/#" },
              { title: "Rotation Planner", link: "/#" },
              { title: "Injuries/Suspension", link: "/#" },
            ]}
          />

          <NavDropDownMenu
            menuTitle="Price Change Stats"
            items={[
              { title: "Price Change Predictor", link: "/#" },
              { title: "Transfer Stats", link: "/#" },
            ]}
          />

          <NavDropDownMenu
            menuTitle="Fix Predictive Stats"
            items={[
              { title: "Predicted Points & Stats", link: "/#" },
              { title: "Predicted Line Ups", link: "/#" },
              { title: "Fixture Analyzer", link: "/#" },
            ]}
          />
          <NavDropDownMenu
            menuTitle="Fix Stats"
            items={[
              { title: "Player Heatmaps", link: "/#" },
              { title: "Opta Stats Sandbox", link: "/#" },
              { title: "Custom Stats Builder", link: "/#" },
              { title: "Fix Comparison Matrix", link: "/#" },
              { title: "FPL Statistics", link: "/#" },
            ]}
          />

          <NavDropDownMenu
            menuTitle="Gameweek Live"
            items={[
              { title: "Gameweek Live", link: "/#" },
              { title: "Match Stats", link: "/#" },
              { title: "Fix Rivals", link: "/#" },
              { title: "Mini Leagues", link: "/#" },
              { title: "Rank Prediction", link: "/#" },
            ]}
          />

          <NavDropDownMenu
            menuTitle="More"
            items={[
              { title: "Premium Fix Memberships", link: "/#" },
              { title: "Preseason Pack Login", link: "/#" },
              { title: "Account Settings", link: "/#" },
              { title: "Notification Settings", link: "/#" },
              { title: "Stat Settings", link: "/#" },
              { title: "Feature Help Videos", link: "/#" },
              { title: "Blog", link: "/#" },
              { title: "Reload Squad", link: "/#" },
              { title: "Logout", link: "/#" },
            ]}
          />
          <li>
            <div className="flex items-center justify-evenly h-full pr-2">
              <button className="bg-red-500 hover:bg-red-600 mx-5 my-5 lg:my-0 lg:mx-2 w-full lg:w-auto py-4 lg:py-2 px-4 font-bold text-white text-xs uppercase">
                Source Code
              </button>
              <NotificationBadge className="hidden lg:flex" />
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </>
);

export default HeaderNavBar;
